/**
 * Renders whatever `useToast` is holding.
 *
 * The provider only keeps the toasts in state — something has to draw them, and until this
 * existed nothing did, so every `addToast` in the app (the login error, for one) was silently
 * doing nothing. Mounted once, next to the routes.
 *
 * `UTToast` removes itself when its progress ring runs out, so there is no cleanup here.
 *
 * @module Shared/components
 */

import { useToast } from '@group-link-one/gl-components';
import { UTToast } from '@group-link-one/gl-ui/utilities';
import type { JSX } from 'react';

export const ToastStack = (): JSX.Element => {
  const { toasts } = useToast();

  return (
    <>
      {toasts.map(toast => (
        <UTToast key={toast.id} position='top-right' {...toast} />
      ))}
    </>
  );
};
